/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION - SUPPLY SIDE PLATFORM PAGE : STYLES --------------- ++++++++++ */
export default {
    supplySidePlatform: {
    }
};
